<template>
  <!-- El root debe existir siempre: va dentro de <Transition mode="out-in"> en App.vue
       y, si el root fuera un v-if=null (nodo comentario), la transicion se atasca y la
       vista no llega a montarse en navegacion cliente (se veia en blanco). -->
  <div class="container-fluid">
    <div class="experience" v-if="experience">
      <!--
        El rastro de migas, con imagenes. Solo aparece si la experiencia forma
        parte de un ciclo: para las sueltas no hay nada que rastrear.
      -->
      <nav class="experience__migas" v-if="migas.length">
        <template v-for="miga in migas" :key="miga.code">
          <button class="experience__migas--paso" @click="irAExperiencia(miga.code)">
            <img :src="imageHost + miga.reducedImageKey" :alt="translate(miga.title)" />
            <span>{{ translate(miga.title) }}</span>
          </button>
          <span class="experience__migas--flecha" aria-hidden="true">&rsaquo;</span>
        </template>
        <span class="experience__migas--paso experience__migas--paso-actual">
          <img :src="imageHost + experience.reducedImageKey" :alt="translate(experience.title)" />
          <span>{{ translate(experience.title) }}</span>
        </span>
      </nav>
      <div
        class="experience--image experience--galeria"
        v-if="experience.gallery && experience.gallery.length"
      >
        <Slider
          heightViewport="auto"
          heightCamera="auto"
          heightDekstopCamera="auto"
          :autoplay="true"
          :autoplayTime="5000"
          :pagination="true"
          :circular="true"
          :bound="false"
          duration="800"
        >
          <template #content>
            <div
              class="flicking-panel"
              v-for="(foto, i) in [experience.imageKey, ...experience.gallery]"
              :key="i"
            >
              <img :src="imageHost + foto" :alt="translate(experience.title)" draggable="false" />
            </div>
          </template>
        </Slider>
      </div>
      <div class="experience--image" v-else>
        <img :src="imageHost + experience.imageKey" />
      </div>
      <div class="experience__info">
        <div class="experience__info--title">
          <IntroTitle
            :title="translate(experience.title)"
            padding="0px"
            paddingDesktop="0px"
            titleFontSize="1.6rem"
            titleMobileFontSize="1.3rem"
            descriptionAlign="initial"
            descriptionMobileAlign="initial"
            :hideActionMobile="true"
            id="menu-options"
          >
            <template #action v-if="!experience.isFreeAccess">
              <div
                :class="[
                  'button-movistar',
                  'button-movistar__primary',
                  {
                    'button-movistar__primary--disabled':
                      experience.schedule && !selectedTime
                  }
                ]"
                @click="goToPersonalData"
              >
                <span>
                  <template v-if="experience.schedule">{{
                    $t('experience.book-tickets')
                  }}</template>
                  <template v-else>{{ $t('experience.take-turn') }}</template>
                </span>
              </div>
            </template>
          </IntroTitle>
        </div>
        <div class="experience__info--labels">
          <IconInfo
            v-for="(attribute, index) in experience.attributes"
            :key="index"
            :title="translate(attribute.localizedValue || attribute.value)"
            icon-background="#E6F5FD"
          >
            <template #icon>
              <img
                v-if="'iconUrl' in attribute"
                v-show="attribute.iconUrl"
                :src="attribute.iconUrl"
                width="17"
                height="17"
                alt=""
              />
              <template v-else>
              <IconClockHour3
                :size="17"
                v-if="attribute.experienceAttributeTypeCode === 'DURATION'"
                color="#008EDD"
              />
              <IconMapPin
                :size="17"
                v-if="attribute.experienceAttributeTypeCode === 'LOCATION'"
                color="#008EDD"
              />
              </template>
            </template>
          </IconInfo>
          <IconInfo
            :title="'Acceso Libre'"
            icon-background="#E6F5FD"
            background="#E6F5FD"
            borderRadius="999px"
            gap="4px"
            titleColor="var(--primary-10-color)"
            paddingBackground="0px 10px 0px 5px"
            v-if="experience.isFreeAccess && !partes.length"
          >
            <template #icon>
              <img src="/img/freepass_hand.svg" />
            </template>
          </IconInfo>
        </div>
      </div>
      <div class="experience__description" v-if="experience.description">
        <span
          class="experience__description--text"
          v-html="translate(experience.description)"
        >
        </span>
      </div>
      <!--
        Un ciclo no se reserva: se reservan sus titulos. Donde iria el
        calendario va la lista de lo que agrupa.
      -->
      <div class="experience__partes" v-if="partes.length">
        <span class="experience__partes--titulo">{{ tituloDeLasPartes }}</span>
        <div class="experience__partes--lista">
          <Card
            v-for="parte in partes"
            :key="parte.code"
            :image="imageHost + parte.reducedImageKey"
            :info="false"
            :title="translate(parte.title)"
            :subtitle="truncate(translate(parte.summary) || '', 80)"
            imageWidth="40%"
            imageDesktopWidth="40%"
            descriptionWidth="70%"
            descriptionDesktopWidth="100%"
            imageHeight="100%"
            titleSize="16px"
            subtitleSize="12px"
            labelGap="5px"
            descriptionJustify="space-between"
            @click="irAExperiencia(parte.code)"
          />
        </div>
      </div>
      <div class="experience__reservation">
        <div
          v-if="reservasMotivo"
          style="grid-column: 1 / -1; justify-self: start; align-self: start; margin: 0; padding: 8px 14px; border-radius: 6px; background: #0b2739; color: #fff; font-size: 14px; font-weight: 700"
        >
          {{ textoDeReservas }}
        </div>
        <div
          v-if="completo"
          style="grid-column: 1 / -1; justify-self: start; align-self: start; margin: 0; padding: 6px 14px; border-radius: 6px; background: #d32f2f; color: #fff; font-size: 14px; font-weight: 700; letter-spacing: 2px; text-transform: uppercase"
        >
          {{ $t('experience.completo') }}
        </div>
        <div
          class="experience__calendar"
          v-if="experience.schedule && !experience.isFreeAccess"
        >
          <span class="experience__calendar--title">{{
            $t('experience.select-date')
          }}</span>
          <div class="experience__calendar--picker">
            <Calendar
              :disabled-dates="disabledDates"
              :min-date="new Date(experience.schedule?.startDate)"
              :max-date="
                experience.schedule?.endDate
                  ? new Date(experience.schedule?.endDate)
                  : undefined
              "
              v-model="date"
              @dayclick="selectDay"
              @update:pages="changePage"
            />
          </div>
        </div>
        <div
          class="experience__schedule"
          v-if="selectedSlot?.times.length > 0 && !experience.isFreeAccess"
        >
          <div class="experience__schedule--title">
            {{
              new Intl.DateTimeFormat(i18n.global.locale.value, {
                weekday: 'short',
                month: 'long',
                day: 'numeric'
              }).format(date)
            }}
          </div>
          <div class="experience__schedule--hours top-to-bottom--efect">
            <Badge
              v-for="hour in selectedSlot.times"
              :key="hour.time"
              :title="hour.time"
              :hour="hour.time"
              :avaiable="hour.availability"
              :selectedHour="selectedTime?.time"
              @click="selectTime(hour)"
            />
          </div>
          <div
            v-if="recorte"
            style="margin-top: 12px; padding: 10px 14px; border-radius: 8px; background: #fff4e5; color: #663c00; font-size: 14px; line-height: 1.4"
          >
            {{
              $t('experience.aforo.recorte', {
                hora: recorte.hora,
                quedan: recorte.quedan,
                pedidas: recorte.pedidas
              })
            }}
            <template v-if="recorte.otras.length">
              {{
                $t('experience.aforo.alternativas', {
                  pedidas: recorte.pedidas,
                  horas: recorte.otras.join(', ')
                })
              }}
            </template>
            <template v-else>
              {{ $t('experience.aforo.sinAlternativas', { pedidas: recorte.pedidas }) }}
            </template>
          </div>
        </div>
      </div>
      <div
        class="experience__audience"
        v-if="experience.schedule && !experience.isFreeAccess"
      >
        <div class="experience__audience--title">
          {{ $t('experience.audience') }}
        </div>
        <div class="experience__audience--increment">
          <Increment
            :max="topeDeAsistentes()"
            :valor="audience"
            @update:total="getIncrement"
          />
        </div>
      </div>
      <div
        v-if="completo && espera.enabled"
        style="grid-column: 1 / -1; margin: 4px 0 0; padding: 16px; border: 1px solid #d9dde3; border-radius: 10px"
      >
        <div style="font-size: 16px; font-weight: 700; color: #313235">
          {{ $t('experience.espera.titulo') }}
        </div>
        <p style="margin: 6px 0 0; font-size: 14px; line-height: 1.45; color: #5b6670">
          {{
            espera.waiting === 0
              ? $t('experience.espera.nadie')
              : espera.waiting === 1
                ? $t('experience.espera.unoEspera')
                : $t('experience.espera.hayGente', { n: espera.waiting })
          }}
          {{ $t('experience.espera.explica') }}
        </p>

        <p
          v-if="esperaHecha"
          style="margin: 12px 0 0; padding: 10px 14px; border-radius: 8px; background: #e8f5e9; color: #1b5e20; font-size: 14px; line-height: 1.45"
        >
          {{ $t('experience.espera.apuntado') }}
        </p>

        <form v-else style="margin-top: 12px" @submit.prevent="apuntarse($i18n.locale)">
          <input
            v-model="esperaDatos.name"
            type="text"
            required
            maxlength="120"
            :placeholder="$t('experience.espera.nombre')"
            style="display: block; width: 100%; margin-bottom: 8px; padding: 10px 12px; border: 1px solid #d9dde3; border-radius: 8px; font-size: 14px"
          />
          <input
            v-model="esperaDatos.email"
            type="email"
            required
            maxlength="190"
            :placeholder="$t('experience.espera.correo')"
            style="display: block; width: 100%; margin-bottom: 8px; padding: 10px 12px; border: 1px solid #d9dde3; border-radius: 8px; font-size: 14px"
          />
          <p style="margin: 0 0 10px; font-size: 13px; color: #5b6670">
            {{ audience === 1 ? $t('experience.espera.personaUna') : $t('experience.espera.personas', { n: audience }) }}
          </p>
          <button
            type="submit"
            :disabled="esperaEnviando"
            style="padding: 10px 20px; border: 0; border-radius: 8px; background: #0B9CEA; color: #fff; font-size: 14px; font-weight: 700; cursor: pointer"
          >
            {{ esperaEnviando ? $t('experience.espera.enviando') : $t('experience.espera.boton') }}
          </button>
          <p v-if="esperaError" style="margin: 8px 0 0; color: #d32f2f; font-size: 13px">
            {{ $t('experience.espera.error') }}
          </p>
        </form>
      </div>
      <div class="experience__terms">
        <IconInfo
          font-size="16px"
          title-weight="700"
          :title="
            experience.isFreeAccess
              ? $t('experience.terms.title')
              : $t('experience.terms.title')
          "
          padding="0px"
        >
          <template #icon>
            <IconAlertCircle :size="22" color="#313235" />
          </template>
        </IconInfo>
        <span
          class="experience__terms--label"
          v-if="experience.code != 'STU1' && experience.code != 'STU2'"
        >
          <span
            v-if="translate(experience.notice)"
            v-html="translate(experience.notice)"
          ></span>
          <template v-else-if="experience.isFreeAccess">
            {{ $t('experience.terms.freepass.zone') }}
            {{ translate(experienceType?.title) }}
            {{ $t('experience.terms.freepass.activity') }}
          </template>
          <template v-else>
            <span v-html="$t('experience.terms.label')"></span>
          </template>
        </span>
        <span
          class="experience__terms--label"
          v-if="experience.code === 'STU1' || experience.code === 'STU2'"
          v-html="experience.isFreeAccess ? '' : $t('experience.terms.studio')"
        >
        </span>
      </div>
      <div class="experience__map" v-if="experience.isFreeAccess"></div>
      <div class="experience__book" v-if="!experience.isFreeAccess">
        <div
          :class="[
            'button-movistar',
            'button-movistar__primary',
            {
              'button-movistar__primary--disabled':
                experience.schedule && !selectedTime
            }
          ]"
          @click="goToPersonalData"
        >
          <IconLoader2 v-if="isLoading" class="spinner-icon" />
          <span v-else>
            <template v-if="experience.schedule">{{
              $t('experience.book-tickets')
            }}</template>
            <template v-else>{{ $t('experience.take-turn') }}</template></span
          >
        </div>
      </div>
    </div>
    <QrTotem
      :abierto="qrReservaAbierto"
      :qr="qrReserva"
      titulo="totem.reserva.title"
      texto="totem.reserva.text"
      @cerrar="qrReservaAbierto = false"
    />
  </div>
</template>

<script setup>
  import {
    IconClockHour3,
    IconMapPin,
    IconAlertCircle,
    IconViewfinder,
    IconLoader2
  } from '@tabler/icons-vue'
  import { ref, computed, onBeforeMount, onMounted, watch } from 'vue'
  import { useStore } from 'vuex'
  import router from '@/router'
  import getSlots from '@/plugins/getSlots'
  import IconInfo from '@/components/movistar/common/IconInfo.vue'
  import Increment from '@/components/movistar/common/NumberIncrement.vue'
  import IntroTitle from '@/components/movistar/common/IntroTitle.vue'
  import Badge from '@/components/movistar/common/Badge.vue'
  import Calendar from '@/components/movistar/common/Calendar.vue'
  import Card from '@/components/movistar/cards/Card.vue'
  import Slider from '@/components/movistar/common/Slider.vue'
  import commonMethods from '@/commonMethods'
  import i18n from '@/plugins/i18n'
  import QrTotem from '@/components/movistar/common/QrTotem.vue'
  import { enlaceDeLaWeb, imagenDelQr } from '@/plugins/qrTotem'

  // Se pinta solo cuando el API dice que no queda ni una plaza en ninguna
  // fecha ofertada. Arranca en false para que una experiencia con sitio no
  // parpadee un COMPLETO mientras se contesta.
  const completo = ref(false)

  // Por que no se puede reservar aun o ya: '' | 'booking_not_open' | 'booking_closed'.
  // Y, si aun no abren, cuando (dia en la sede, `YYYY-MM-DD`, y hora, `HH:MM`).
  const reservasMotivo = ref('')
  const reservasAbren = ref(null)
  const textoDeReservas = computed(() => {
    if (reservasMotivo.value === 'booking_not_open' && reservasAbren.value) {
      const [a, m, d] = reservasAbren.value.dia.split('-').map(Number)
      const dia = new Date(a, m - 1, d).toLocaleDateString(i18n.global.locale.value, { day: 'numeric', month: 'long' })
      return i18n.global.t('experience.reservas.not-open', { dia, hora: reservasAbren.value.hora })
    }
    return i18n.global.t('experience.reservas.closed')
  })

  // Cuanta gente admite UNA reserva de esta experiencia. Null mientras no
  // se sepa y tambien cuando no hay tope, que son casos distintos con la
  // misma consecuencia: manda lo que quede en la hora elegida.
  const topePorReserva = ref(null)

  const store = useStore()
  const { registerError, translate, truncate, scrollToClassName } =
    commonMethods()

  /*
   * Navegacion por ciclos (EV-07).
   *
   * Bajo bandera de compilacion: solo el modo de la maqueta la enciende, asi
   * que el bundle que se genera para produccion se comporta exactamente igual
   * que hoy. Cuando se pueda tocar el frontal de verdad, se quita la bandera.
   */
  const ciclos = process.env.VUE_APP_CICLOS === 'true'

  const props = defineProps({
    experienceCode: { type: String }
  })

  onMounted(async () => {
    const scrollToClass = router.currentRoute.value.query.scrollToClass
    if (scrollToClass) {
      scrollToClassName(scrollToClass)
    }
  })

  /*
   * Se saca de onBeforeMount porque ahora se navega de una experiencia a otra
   * dentro de la misma ruta —del ciclo a su titulo—, y ahi Vue reutiliza el
   * componente y los ganchos de montaje no se vuelven a disparar.
   */
  const cargarExperiencia = async () => {
    experience.value = await store.dispatch(
      'getExperienceByCode',
      props.experienceCode
    )
    if (!experience.value) {
      registerError(
        'ExperienceView',
        `Error al recuperar la experiencia con identificador ${props.experienceCode}`
      )

      router.push({
        name: 'Home'
      })
    } else {
      if (experience.value.schedule) {
        const completoAlCargar = async () => {
          try {
            const r = await fetch(
              `${process.env.VUE_APP_PATH}calendar/${experience.value.schedule.id}/estado` +
                `?storeId=${experience.value.schedule.branchId}`,
              { headers: { Accept: 'application/json' } }
            )

            if (r.ok) {
              const estado = await r.json()

              completo.value = estado.soldOut === true
              // «Reservas disponibles desde / hasta»: aun no abren o ya cerraron.
              reservasMotivo.value = ['booking_not_open', 'booking_closed'].includes(estado.reason) ? estado.reason : ''
              reservasAbren.value = estado.opensOn ? { dia: estado.opensOn, hora: estado.opensAt } : null
              topePorReserva.value = estado.maxPerBooking ?? null
              espera.value = estado.waitingList ?? { enabled: false, waiting: 0 }
            }
          } catch (e) {
            // Sin cartel, como hasta hoy.
          }
        }

        completoAlCargar()

        const setDate = async () => {
          slots = await getSlots(
            experience.value.schedule.id,
            experience.value.schedule.branchId,
            new Date()
          )

          if (slots?.length > 0) {
            selectedSlot.value = slots[0]
            date.value = new Date(slots[0].date)

            disabledDates.value = allDatesInMonth.filter((date) => {
              return !slots.some((slot) => {
                return new Date(slot.date).getTime() === date.getTime()
              })
            })
          }
        }

        setDate()
      }
    }
  }

  onBeforeMount(cargarExperiencia)

  /*
   * Al cambiar de experiencia sin cambiar de ruta hay que soltar lo elegido
   * para la anterior: si no, el calendario del titulo nuevo arrancaria con la
   * hora que se habia marcado en el anterior.
   */
  watch(
    () => props.experienceCode,
    () => {
      experience.value = null
      selectedSlot.value = null
      selectedTime.value = null
      date.value = null
      disabledDates.value = []
      cargarExperiencia()
      window.scrollTo({ top: 0 })
    }
  )

  const irAExperiencia = (code) => {
    router.push({ name: 'Experience', params: { experienceCode: code } })
  }

  // Lo que agrupa y el camino hasta la raiz. Vacios si la bandera esta baja,
  // de modo que la plantilla se comporta como antes sin condicionarla dos veces.
  const partes = computed(() =>
    ciclos ? experience.value?.parts || [] : []
  )
  const migas = computed(() => (ciclos ? experience.value?.path || [] : []))

  const tituloDeLasPartes = computed(() =>
    partes.value.length === 1
      ? 'Incluye esta experiencia'
      : `Incluye estas ${partes.value.length} experiencias`
  )

  const imageHost = ref(process.env.VUE_APP_IMAGE_HOST)

  let isLoading = ref(false)
  let date = ref(null)
  let selectedSlot = ref(null)
  let selectedTime = ref(null)
  let experience = ref(null) //computed(() => store.getters['getExperience'])
  let experienceType = computed(() => store.state.experience.experienceType)
  let audience = ref(1)

  // Que se recorto, por que y donde si cabe el grupo. Null mientras no haya
  // nada que contar, que es lo normal.
  const recorte = ref(null)

  /**
   * El tope del contador de asistentes: el menor de los dos que hay.
   *
   * Las plazas que queden a la hora elegida, y las que la ficha admita en
   * una sola reserva. Antes solo se miraba la primera, y el servidor
   * rechaza por la segunda: se podian pedir noventa en un pase de noventa
   * y descubrir el limite despues de rellenar los datos.
   *
   * Sin ninguno de los dos, cuatro: es lo que hacia esta pagina desde
   * siempre y no hay motivo para cambiarlo a ciegas.
   */
  const topeDeAsistentes = () => {
    const topes = [
      selectedTime.value ? selectedTime.value.availability : null,
      topePorReserva.value
    ].filter((n) => n != null)

    return topes.length ? Math.min(...topes) : 4
  }
  let slots
  let disabledDates = ref([])
  const currentDate = new Date()
  let selectedMonth = currentDate.getMonth() + 1
  let numberOfDaysInCurrentMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  ).getDate()
  let allDatesInMonth = []
  for (let index = 1; index <= numberOfDaysInCurrentMonth; index++) {
    allDatesInMonth.push(
      new Date(currentDate.getFullYear(), currentDate.getMonth(), index)
    )
  }

  disabledDates.value = allDatesInMonth

  const selectDay = (calendarDay, event) => {
    if (!calendarDay.isDisabled) {
      date.value = calendarDay.date
      selectedTime.value = null
      audience.value = 1
      recorte.value = null

      const fSlot = slots.find((slot) => {
        return new Date(slot.date).getTime() === calendarDay.date.getTime()
      })

      selectedSlot.value = fSlot
    }
  }

  const selectTime = (time) => {
    selectedTime.value = time
    recorte.value = null

    const quedan = time.availability

    if (quedan != null && audience.value > quedan) {
      // Las horas de ESE dia donde si cabe el grupo entero, que es la
      // pregunta siguiente y el frontal ya tiene la respuesta.
      const otras = (selectedSlot.value?.times || [])
        .filter((h) => h.time !== time.time && (h.availability ?? 0) >= audience.value)
        .map((h) => h.time)

      recorte.value = { hora: time.time, quedan, pedidas: audience.value, otras }

      audience.value = Math.max(1, quedan)
    }

    store.commit('setSlot', new Date(selectedSlot.value.date + ' ' + time.time))
  }

  const changePage = async (page) => {
    if (page?.length > 0) {
      const currentPage = page[0]

      if (selectedMonth != currentPage.month) {
        selectedMonth = currentPage.month
        numberOfDaysInCurrentMonth = currentPage.monthComps.numDays
        allDatesInMonth = []
        for (let index = 1; index <= numberOfDaysInCurrentMonth; index++) {
          allDatesInMonth.push(
            new Date(currentPage.year, currentPage.month - 1, index)
          )
        }

        disabledDates.value = allDatesInMonth

        slots = await getSlots(
          experience.value.schedule.id,
          experience.value.schedule.branchId,
          currentPage.monthComps.firstDayOfMonth
        )

        if (slots?.length > 0) {
          disabledDates.value = allDatesInMonth.filter((date) => {
            return !slots.some((slot) => {
              return new Date(slot.date).getTime() === date.getTime()
            })
          })
        }
      }
    }
  }

  /*
   * La lista de espera, que hasta hoy existia entera por detras -alta, cola,
   * ofertas y correos- y no tenia donde pulsarse.
   *
   * Solo se pinta con COMPLETO y con la lista encendida en la ficha, que son
   * las dos condiciones que ya contesta `/estado` en la misma llamada del
   * cartel: no hay peticion nueva.
   *
   * SIEMPRE «cualquier pase», y no es un atajo: si la experiencia esta
   * completa, `slots` no devuelve ni una hora, asi que no hay ninguna que
   * elegir. Apuntarse a una hora concreta solo tendria sentido el dia que se
   * pueda estar completo a las 17:00 y con sitio a las 19:00.
   */
  const espera = ref({ enabled: false, waiting: 0 })
  const esperaDatos = ref({ name: '', email: '' })
  const esperaEnviando = ref(false)
  const esperaHecha = ref(false)
  const esperaError = ref(false)

  const apuntarse = async (idioma) => {
    esperaEnviando.value = true
    esperaError.value = false

    try {
      const r = await fetch(
        `${process.env.VUE_APP_PATH}waiting-list?storeId=${experience.value.schedule.branchId}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            experienceCode: experience.value.code,
            name: esperaDatos.value.name,
            email: esperaDatos.value.email,
            audience: audience.value,
            anySlot: true,
            locale: idioma
          })
        }
      )

      if (!r.ok) throw new Error(r.status)

      const d = await r.json()

      // Cuanta gente hay AHORA, contando a quien se acaba de apuntar: es lo
      // que contesta el alta y evita tener que volver a preguntarlo.
      if (typeof d.waiting === 'number') espera.value.waiting = d.waiting

      esperaHecha.value = true
    } catch (e) {
      esperaError.value = true
    } finally {
      esperaEnviando.value = false
    }
  }

  const getIncrement = (value) => {
    audience.value = value
  }

  const qrReserva = ref('')
  const qrReservaAbierto = ref(false)
  const goToPersonalData = () => {
    if (sessionStorage.getItem('modoTotem') === '1') {
      if (experience.value.schedule && !selectedTime.value) return
      const pase = store.getters['getSlot']
      qrReserva.value = imagenDelQr(enlaceDeLaWeb({
        path: 'personalData',
        type: store.getters['getExperienceType']?.code || experience.value.experienceType?.code,
        code: experience.value.code,
        slot: experience.value.schedule && pase ? new Date(pase).getTime() : null,
        audience: audience.value,
        lang: i18n.global.locale.value
      }))
      qrReservaAbierto.value = true
      return
    }
    try {
      isLoading.value = true
      if (!experience.value.schedule || selectedTime.value)
        router.push({
          name: 'PersonalData',
          params: { audience: audience.value }
        })
    } finally {
      isLoading.value = false
    }
  }
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .experience {
    width: 100%;

    /* El rastro de migas: por donde se ha llegado hasta aqui, con imagenes. */
    &__migas {
      @include d-flex(row, flex-start, center, 6px);
      flex-wrap: wrap;
      padding: 12px 15px;
      background: #f4f6f8;
      @media screen and (min-width: $sm-breakpoint) {
        padding: 14px 50px;
      }

      &--paso {
        @include d-flex(row, flex-start, center, 8px);
        max-width: 46dvw;
        padding: 4px 12px 4px 4px;
        border: 1px solid #e0e5e9;
        border-radius: 999px;
        background: #fff;
        font: inherit;
        color: inherit;
        cursor: pointer;

        & img {
          flex: 0 0 auto;
          width: 34px;
          height: 26px;
          border-radius: 6px;
          object-fit: cover;
        }

        & span {
          overflow: hidden;
          font-size: 13px;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      &--paso-actual {
        border-color: transparent;
        background: var(--primary-40-color);
        color: #fff;
        cursor: default;
      }

      &--flecha {
        color: #9aa5ad;
        font-size: 18px;
      }
    }

    /* Lo que agrupa un ciclo, donde en una experiencia normal va el calendario. */
    &__partes {
      @include d-flex(column, flex-start, stretch, 14px);
      padding: 15px;
      border-bottom: 1px #d6d6d6 solid;
      @media screen and (min-width: $sm-breakpoint) {
        padding: 25px 50px;
      }

      &--titulo {
        @include experience-font(1.1rem, --fw-bold);
      }

      &--lista {
        display: grid;
        gap: 12px;
        grid-template-columns: 1fr;
        @media screen and (min-width: $sm-breakpoint) {
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
        }
      }
    }
    &--image {
      width: 100%;

      & img {
        width: 100dvw;
      }
    }
    &--galeria {
      position: relative;

      & .flicking-panel img {
        display: block;
        width: 100%;
        aspect-ratio: 3 / 1;
        object-fit: cover;
      }
    }
    &__info {
      @include d-flex(column, flex-start, flex-start, 10px);
      padding: 15px;
      border-bottom: 1px #d6d6d6 solid;
      &--title {
        @include d-flex(row, space-between, flex-start, 10px);
        width: 100%;
      }
      &--labels {
        @include d-flex(column, flex-start, flex-start, 10px);
        @media screen and (min-width: $sm-breakpoint) {
          @include d-flex(row, flex-start, flex-start, 15px);
        }
      }
      @media screen and (min-width: $sm-breakpoint) {
        padding: 30px 50px;
      }
    }
    &__description {
      @include d-flex(row, center, center, 10px);
      padding: 15px;
      border-bottom: 1px var(--neutral-20) solid;
      &--text {
        @include experience-font(1rem, --fw-normal);
        line-height: var(--fs-xx-large);
        h1, h2, h3, h4, h5, h6 {
          margin: 0.8em 0 0.3em;
          line-height: 1.25;
          font-weight: 700;
        }
        h1 { font-size: 1.75rem; }
        h2 { font-size: 1.5rem; }
        h3 { font-size: 1.3rem; }
        h4 { font-size: 1.15rem; }
        h5 { font-size: 1rem; }
        h6 { font-size: 0.875rem; text-transform: uppercase; letter-spacing: 0.04em; }
        > :first-child { margin-top: 0; }
      }
      @media screen and (min-width: $sm-breakpoint) {
        @include d-flex(row, flex-start, center, 10px);
        padding: 15px 50px;
      }
    }
    &__reservation {
      display: grid;
      padding: 15px;
      @media screen and (min-width: $sm-breakpoint) {
        grid-template-columns: repeat(1, 1fr);
        padding: 15px 50px;
        gap: 50px;
      }
      @media screen and (min-width: $md-breakpoint) {
        grid-template-columns: repeat(2, 1fr);
      }
    }
    &__calendar {
      @include d-flex(column, flex-start, flex-start, 15px);
      padding: 15px 0px;
      width: 100%;
      align-items: flex-start;
      &--title {
        @include experience-font(var(--fs-large), --fw-medium);
      }
      &--picker {
        @include d-flex(row, center, center);
        width: 100%;
      }
    }
    &__schedule {
      @include d-flex(column, flex-start, flex-start, 20px);
      width: 100%;
      padding: 15px 0;
      &--title {
        @include experience-font(1rem, --fw-medium);
      }
      &--hours {
        @include d-flex(row, center, initial);
        gap: 15px;
        flex-wrap: wrap;
        width: 100%;
        @media screen and (min-width: $sm-breakpoint) {
          @include d-flex(row, initial, initial, 15px);
        }
      }
    }
    &__audience {
      @include d-flex(column, flex-start, flex-start, 20px);
      width: 100%;
      padding: 15px;
      &--title {
        @include experience-font(1rem, --fw-medium);
      }
      &--increment {
        @include d-flex(row, center, center, 0px);
        padding: 4px;
        color: var(--primary-50-color);
      }
      @media screen and (min-width: $sm-breakpoint) {
        padding: 15px 50px;
      }
    }
    &__terms {
      @include d-flex(column, initial, initial);
      gap: 10px;
      padding: 15px;
      &--label {
        color: #313235;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
      @media screen and (min-width: $sm-breakpoint) {
        padding: 15px 50px;
      }
    }
    &__book {
      @include d-flex(row, center, center, 0px);
      width: 100%;
      height: 96px;
      padding: 0 20px;
      background-color: #fff;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      border-top: 1px #f6f6f6 solid;
      position: fixed;
      z-index: 1;
      bottom: 0px;
      @media screen and (min-width: $sm-breakpoint) {
        display: none;
      }
    }
    &__map {
      width: 100%;
      padding: 15px;
      margin-top: -120px;
      &--img {
        width: 100%;
        @media screen and (min-width: $sm-breakpoint) {
          width: 350px;
        }
      }
      @media screen and (min-width: $sm-breakpoint) {
        @include d-flex(row, flex-start, center, 10px);
        padding: 15px 50px 50px 50px;
      }
    }
    > :nth-last-child(2) {
      margin-bottom: 120px;
    }
  }
</style>
